import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3256605479/src/Portfolio/src/components/navBar/navBar.tsx");
